module.exports = __webpack_public_path__ + "static/media/ZeroButtonHover.e7e995f3.svg";